import { Series } from './Series';

export default Series;
